import { environment } from 'src/environments/environment';
import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-favorite',
  templateUrl: './favorite.page.html',
  styleUrls: ['./favorite.page.scss'],
})
export class FavoritePage implements OnInit {
  myFav: any = [];
  s3_url: string = environment.s3_bucket_url;
  profilePlaceholder: string = '../../../assets/images/profile-placeholder.png';
  constructor(
    private apiService: ApiService,
    private router: Router,
  ) { }

  ngOnInit() {
  }
  ionViewWillEnter(){
    this.apiService.get('users/getFavourite').subscribe((res) => {
      this.myFav = res['data'];
    });
  }
  goToProfile(account_type, user_id){
    let type = 'user';
    if(account_type == 1)
      type = 'band';
    else if(account_type == 2)
      type = 'comedian';
    else if(account_type == 3)
      type = 'food-truck';
    else if(account_type == 4)
      type = 'user';
    else if(account_type == 5)
      type = 'venue';
    else if(account_type == 6)
      type = 'comedy-club';
    else if(account_type == 7)
      type = 'artist';
    this.router.navigate([type + '/' + btoa(user_id)]);
  }
}
